import { css, cx } from 'emotion';
import React from 'react';

const buttonContainerStyle = css`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-block: 1rem;
  margin-top: auto;
  z-index: 2;

  > div:first-child {
    width: 100%;
    margin-top: -0.75rem;
  }
  > button:only-child {
    margin-left: auto;
  }
`;
const stickyBottomStyle = css`
  padding: 1rem 0;
  margin-bottom: 0;
  background-color: var(--white);
  border-top: 1px solid var(--primaryBrand);
  position: sticky;
  bottom: 0;
`;

const bottomOffsetStyle = css`
  @media (max-width: 768px) {
    bottom: 5.5rem;
  }
`;

export const ButtonContainer = props => {
  const { children, customAlignment, stickyBottom, bottomOffset } = props;
  return (
    <div
      className={cx(
        buttonContainerStyle,
        customAlignment,
        stickyBottom && stickyBottomStyle,
        bottomOffset && bottomOffsetStyle
      )}
    >
      {children}
    </div>
  );
};
